import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Brain, MessageCircle, BookOpen, Calculator, Heart, Compass } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: <Brain size={20} data-id="element-223" />,
    title: 'Atención, Funciones Ejecutivas y Autorregulación',
    desc: 'Atención sostenida, memoria de trabajo, planificación y autorregulación.',
    tone: 'accent'
  }, {
    icon: <MessageCircle size={20} data-id="element-224" />,
    title: 'Comprensión, Lenguaje y Comunicación Funcional',
    desc: 'Vocabulario, comprensión, inferencias y comunicación pragmática.',
    tone: 'sky'
  }, {
    icon: <BookOpen size={20} data-id="element-225" />,
    title: 'Lectura, Escritura y Producción Escolar',
    desc: 'Lectura funcional, comprensión lectora y producción escrita guiada.',
    tone: 'accent'
  }, {
    icon: <Calculator size={20} data-id="element-226" />,
    title: 'Matemática Funcional, Lógica y Resolución de Problemas',
    desc: 'Numeración aplicada, lógica, secuencias y resolución de problemas.',
    tone: 'sky'
  }, {
    icon: <Heart size={20} data-id="element-227" />,
    title: 'Regulación Emocional, Conducta y Habilidades Sociales',
    desc: 'Identificación emocional, tolerancia a la frustración y habilidades sociales.',
    tone: 'accent'
  }, {
    icon: <Compass size={20} data-id="element-228" />,
    title: 'Inclusión, Autonomía y Organización Escolar/Profesional',
    desc: 'Rutinas, hábitos, autonomía y participación en contextos inclusivos.',
    tone: 'sky'
  }];
  const extras = ['Actividades imprimibles', 'Recursos visuales', 'Plantillas listas para usar', 'Organizado por edades (7–9 · 10–12 · 13–16)'];
  return <section className="pt-6 pb-10" data-id="element-229">
      <div className="max-w-4xl mx-auto px-3" data-id="element-230">
        <FadeIn className="text-center mb-8" data-id="element-231">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ink mb-2" data-id="element-232">
            🎨Qué incluye el MegaPack Inclusión Lista
          </h2>
          <p className="text-sm text-muted font-medium" data-id="element-233">
            6 tomos principales listos para usar
          </p>
        </FadeIn>

        <FadeIn data-id="element-234">
          <div className="grid md:grid-cols-2 gap-3 mb-8" data-id="element-235">
            {tomos.map((tomo, idx) => {
            const isSky = tomo.tone === 'sky';
            return <div key={idx} className={`flex items-start gap-3 bg-surface border rounded-xl p-4 ${isSky ? 'border-sky/20' : 'border-accent/15'}`} data-id="element-236">
                  <div className={`shrink-0 mt-0.5 p-2 rounded-lg ${isSky ? 'bg-sky/10 text-sky' : 'bg-accent/10 text-accent'}`} data-id="element-237">
                    {tomo.icon}
                  </div>
                  <div data-id="element-238">
                    <h3 className="text-ink text-sm font-bold mb-1" data-id="element-239">
                      {tomo.title}
                    </h3>
                    <p className="text-muted text-xs leading-relaxed" data-id="element-240">
                      {tomo.desc}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-241">
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-242">
            {extras.map((item, idx) => {
            const isSky = idx % 2 === 1;
            return <span key={idx} className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border ${isSky ? 'bg-sky/5 border-sky/25 text-sky' : 'bg-accent/5 border-accent/20 text-accent'}`} data-id="element-243">
                  {item}
                </span>;
          })}
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-244">
          <p className="text-center text-muted/80 text-sm font-medium" data-id="element-245">
            Cada tomo incluye plantillas, recursos visuales y propuestas
            organizadas por edades.
          </p>
        </FadeIn>
      </div>
    </section>;
}